import React from "react";
import { render } from "react-dom";
import { ReactSVG } from "react-svg";
import loadingsvg from "../../assets/svg/loading.svg";

const LoadingNode = () => {
  return (
    <div className=" fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[999] w-full h-full  backdrop-blur-[7px] flex items-center justify-center">
      <ReactSVG
        className="animate-spin"
        beforeInjection={(svg) => {
          svg.classList.add("loadingsvg");
        }}
        src={loadingsvg}
      />
    </div>
  );
};

class Loading extends React.Component {
  constructor(props) {
    super(props);
    let element = document.createElement("div");
    element.id = "other-root";
    this.state = {
      element,
    };
  }
  open = (data) => {
    const { element } = this.state;
    document.body.appendChild(element);
    render(<LoadingNode />, element);
  };
  close = () => {
    const { element } = this.state;
    element.remove();
  };
}

const loading = new Loading();
export default loading;
